import "./App.css";
import LandingPage from "./pages/LandingPage";
import VideoPage from "./pages/VideoPage";
import { Route, Switch } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});
export const config = {
  endpoint:
    "https://34ea8ef7-0a4b-4b7c-850f-99230c460da8.mock.pstmn.io/v1/videos",
};
function App() {
  return (
    <div>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/:videoId" component={VideoPage} />
        </Switch>
      </ThemeProvider>
    </div>
  );
}

export default App;
